<div class="toolbar">
  <div class="left">
    <button type="button" aria-label="icon button with a ? icon" mat-icon-button (click)="showHelp ? dismissHelp() : onShowHelp()">
      <mat-icon style="font-size: 30px">help_outline</mat-icon>
    </button>
  </div>

  <div class="right">
    <button mat-stroked-button class="align-middle" (click)="back()" matTooltip="{{ 'common.save' | translate }}" [disabled]="!pageLoaded">
      {{ "common.cancel" | translate }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      class="align-middle color-button"
      (click)="save()"
      matTooltip="{{ 'common.save' | translate }}"
      [disabled]="!pageLoaded"
    >
      <mat-icon>save</mat-icon>
      {{ "common.save" | translate }}
    </button>
  </div>
</div>
<div class="page-container">
  <div class="loading" *ngIf="!pageLoaded || saveInProgress">
    <div class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
    {{ (saveInProgress ? "common.saveInProgress" : "common.loading") | translate }}
  </div>
  <ng-container *ngIf="pageLoaded && !saveInProgress">
    <ui-alert #helpAlert [options]="{ type: 'info', closable: true, fadeOut: true }" (dismiss)="showHelp = false" *ngIf="showHelp">
      {{ "globalHelp.preferenceHelpP1" | translate }} <br />
      {{ "globalHelp.preferenceHelpP2" | translate }} <br />
      {{ "globalHelp.preferenceHelpP3" | translate }}
    </ui-alert>
    <form [formGroup]="preferenceForm">
      <p *ngIf="errorMessage" class="error">
        {{ "api.errors." + errorMessage | translate }}
      </p>
      <div class="group-container">
        <mat-card class="group">
          <h3>{{ "page.preference.tab-general" | translate }} :</h3>
          <p>
            <mat-form-field>
              <mat-label>{{ "page.preference.defaultLandingPage" | translate }}</mat-label>
              <mat-select formControlName="defaultLandingPage">
                <mat-option *ngFor="let page of landingPages" [value]="page">
                  {{ "page." + page + ".title" | translate }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="isFieldValid('defaultLandingPage')">
                {{ "page.preference.defaultLandingPageRequired" | translate }}</mat-error
              >
            </mat-form-field>
          </p>
          <p>
            <mat-form-field>
              <mat-label>{{ "page.preference.preferredLanguage" | translate }}</mat-label>
              <mat-select formControlName="preferredLanguage">
                <mat-option *ngFor="let language of availableLangs" [value]="language.term">
                  {{ language | getTranslation : language.term }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="isFieldValid('preferredLanguage')">
                {{ "page.preference.preferredLanguageRequired" | translate }}</mat-error
              >
            </mat-form-field>
          </p>
          <p>
            <mat-form-field>
              <mat-label>{{ "page.preference.preferredOrg" | translate }}</mat-label>
              <mat-select formControlName="preferredOrg" [compareWith]="compareReference">
                <mat-option *ngIf="availableOrgs?.length >= 2" [value]="sessionService.allsReference">
                  {{ "page.preference.all" | translate }}
                </mat-option>
                <mat-option *ngFor="let org of availableOrgs" [value]="org">
                  {{ org.display }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="isFieldValid('preferredOrg')"> {{ "page.preference.preferredOrgRequired" | translate }}</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field>
              <mat-label>{{ "page.preference.preferredService" | translate }}</mat-label>
              <mat-select formControlName="preferredService" [compareWith]="compareReference">
                <mat-option *ngIf="availableServices?.length >= 2" [value]="sessionService.allsReference">
                  {{ "page.preference.all" | translate }}
                </mat-option>
                <mat-option *ngFor="let service of availableServices" [value]="service">
                  {{ service.display }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="isFieldValid('preferredService')"> {{ "page.preference.preferredServiceRequired" | translate }}</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-checkbox
              formControlName="usePreferredLanguageWhenConflict"
              [indeterminate]="isFieldIndeterminate('usePreferredLanguageWhenConflict')"
            >
              <span class="multiline-label"> {{ "page.preference.alwaysUseMyPreferredLanguage" | translate }}</span>
            </mat-checkbox>
          </p>
          <p>
            <mat-checkbox formControlName="go2PatientAfterInscription" [indeterminate]="isFieldIndeterminate('go2PatientAfterInscription')">
              <span class="multiline-label"> {{ "page.preference.redirectToPatientPage" | translate }}</span>
            </mat-checkbox>
          </p>
        </mat-card>
        <mat-card class="group">
          <h3>{{ "page.preference.connectionOptions" | translate }} :</h3>
          <p class="spacedItem" style="margin-top: 10px">
            <mat-label>{{ "page.patientlist.resetPassword" | translate }} : </mat-label>
            <button mat-stroked-button color="primary" type="button" (click)="displayConfirmResetModal()">
              <mat-icon>lock</mat-icon>
              {{ "page.preference.resetPassword" | translate }}
            </button>
          </p>
          <p *ngIf="country === FRANCE" class="spacedItem">
            <mat-label>{{ "page.preference.togglePSC" | translate }} : </mat-label>
            <mat-slide-toggle formControlName="togglePSC"> </mat-slide-toggle>
          </p>
          <p *ngIf="country !== FRANCE" class="spacedItem">
            <mat-label>{{ "page.preference.toggleEHealth" | translate }} : </mat-label>
            <mat-slide-toggle formControlName="toggleEHealth"> </mat-slide-toggle>
          </p>
          <br />
          <app-mfa-setup></app-mfa-setup>
        </mat-card>
        <mat-card class="group">
          <h3>{{ "page.preference.tab-dashboard" | translate }} :</h3>
          <mat-label>{{ "page.widgetSetting.nbColumn" | translate }} : </mat-label>
          <mat-form-field class="width-50" appearance="none">
            <mat-select formControlName="nbColumn">
              <mat-option *ngFor="let i of [1, 2, 3]" [value]="i">
                {{ i }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldValid('nbColumn')">
              {{ "page.widgetSetting.nbColumnRequired" | translate }}
            </mat-error>
          </mat-form-field>
          <br />
          <mat-label>{{ "page.widgetSetting.widgetList" | translate }} : </mat-label>
          <div *ngFor="let widgetName of availableWidgets">
            <mat-checkbox class="ml-125" [checked]="isEnabledWidget(widgetName)" (change)="changeWidget($event.checked, widgetName)">
              {{ "widget." + widgetName | translate }}
            </mat-checkbox>
          </div>
          <br />
          <mat-label
            >{{ "page.preference.preferredPatientInactivity.title" | translate }}
            :
          </mat-label>
          <mat-radio-group class="radio-button-list" formControlName="inactivityDuration">
            <mat-radio-button class="ml-125" value="1 day">
              {{ "page.preference.preferredPatientInactivity.oneDay" | translate }}
            </mat-radio-button>
            <mat-radio-button class="ml-125" value="1 week">
              {{ "page.preference.preferredPatientInactivity.oneWeek" | translate }}
            </mat-radio-button>
            <mat-radio-button class="ml-125" value="1 month">
              {{ "page.preference.preferredPatientInactivity.oneMonth" | translate }}
            </mat-radio-button>
            <mat-radio-button class="ml-125" value="3 months">
              {{ "page.preference.preferredPatientInactivity.threeMonth" | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </mat-card>

        <mat-card class="group">
          <h3>{{ "page.preference.patientPage" | translate }} :</h3>
          <p>
            <mat-checkbox formControlName="keepLayoutFromPatientPage" [indeterminate]="isFieldIndeterminate('keepLayoutFromPatientPage')">
              {{ "page.preference.keepLayoutFromPatientPage" | translate }}
            </mat-checkbox>
          </p>
          <p>
            <mat-checkbox formControlName="showAllWidgetWhenDetails" [indeterminate]="isFieldIndeterminate('showAllWidgetWhenDetails')">
              {{ "page.preference.showAllWidgetWhenDetails" | translate }}
            </mat-checkbox>
          </p>
          <mat-label>{{ "page.preference.tileList" | translate }} : </mat-label>
          <div cdkDropList (cdkDropListDropped)="tileDropped($event)">
            <div *ngFor="let tileName of availableTile; let index = index; let isFirst = first; let isLast = last" class="tileCheckboxes">
              <div class="arrowsContainer">
                <mat-icon
                  *ngIf="!isFirst"
                  button
                  class="arrow arrowUp"
                  aria-hidden="false"
                  aria-label="Arrow icon"
                  (click)="handleTileArrowClicked(true, index)"
                  >arrow_drop_up
                </mat-icon>
                <mat-icon
                  *ngIf="!isLast"
                  button
                  class="arrow arrowDown"
                  aria-hidden="false"
                  aria-label="Arrow icon"
                  (click)="handleTileArrowClicked(false, index)"
                >
                  arrow_drop_down
                </mat-icon>
              </div>

              <mat-checkbox cdkDrag [checked]="isTileEnabled(tileName)" (change)="changeTile($event.checked, tileName)">
                {{ "tile." + tileName | translate }}
              </mat-checkbox>
            </div>
          </div>
        </mat-card>
        <mat-card class="group">
          <h3>{{ "page.preference.alerts.title" | translate }} :</h3>

          <ng-container *ngIf="!alertPrefLoading; else spinner">
            <p class="spacedItem">
              <mat-label>{{ "page.preference.alerts.byMail" | translate }} : </mat-label>
              <mat-slide-toggle formControlName="toggleAlertCtrl"> </mat-slide-toggle>
            </p>

            <ng-container *ngIf="preferenceForm.get('toggleAlertCtrl').value">
              <mat-label
                >{{ "page.preference.alerts.level.title" | translate }}
                :
              </mat-label>
              <div *ngFor="let alertColor of availableAlertColors">
                <mat-checkbox class="ml-125" [checked]="isEnabledAlert(alertColor)" (change)="changeAlertColor($event.checked, alertColor)">
                  {{ "page.preference.alerts.level." + alertColor | translate }}
                </mat-checkbox>
              </div>
              <br />
              <!-- Sending frequency -->
              <mat-label>{{ "page.preference.alerts.frequency.title" | translate }} :</mat-label>
              <mat-radio-group class="radio-button-list" formControlName="sendMail">
                <mat-radio-button class="ml-125" [value]="SEND_MAIL.IN_REALTIME">
                  {{ "page.preference.alerts.frequency.realtime" | translate }}
                </mat-radio-button>
                <mat-radio-button class="ml-125" [value]="SEND_MAIL.DAILY_SUMMARY">
                  {{ "page.preference.alerts.frequency.daily" | translate }}
                </mat-radio-button>
                <mat-radio-button class="ml-125" [value]="SEND_MAIL.WEEKLY_SUMMARY">
                  {{ "page.preference.alerts.frequency.weekly" | translate }}
                </mat-radio-button>
              </mat-radio-group>

              <br />

              <mat-label *ngIf="availableCareplans.length > 0">{{ "page.preference.alerts.careplans.title" | translate }} :</mat-label>
              <mat-form-field class="full-width" *ngIf="availableCareplans.length > 0">
                <mat-chip-list #chipListCareplans>
                  <mat-chip
                    *ngFor="let careplan of selectedCareplans"
                    [selectable]="true"
                    [removable]="true"
                    (removed)="removeCareplan(careplan)"
                  >
                    {{ careplan.description }}
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input
                    #careplanInput
                    [matAutocomplete]="autoCareplans"
                    [formControl]="careplanCtrl"
                    [matChipInputFor]="chipListCareplans"
                  />
                </mat-chip-list>
                <mat-autocomplete #autoCareplans="matAutocomplete" (optionSelected)="selectCareplan($event.option.value)">
                  <mat-option *ngFor="let option of filteredCareplans | async" [value]="option">
                    {{ option.description }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <br />
              <mat-label *ngIf="availablePatientGroups.length > 0"
                >{{ "page.preference.alerts.patientGroups.title" | translate }} :</mat-label
              >
              <mat-form-field class="full-width" *ngIf="availablePatientGroups.length > 0">
                <mat-chip-list #chipListGroups>
                  <mat-chip *ngFor="let group of selectedGroups" [selectable]="true" [removable]="true" (removed)="removeGroup(group)">
                    {{ group.groupName }}
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input #groupInput [matAutocomplete]="autoGroups" [formControl]="groupCtrl" [matChipInputFor]="chipListGroups" />
                </mat-chip-list>
                <mat-autocomplete #autoGroups="matAutocomplete" (optionSelected)="selectGroup($event.option.value)">
                  <mat-option *ngFor="let option of filteredGroups | async" [value]="option">
                    {{ option.groupName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </ng-container>
          </ng-container>
        </mat-card>
      </div>
    </form>
  </ng-container>
</div>
<ng-template #spinner>
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
